<script setup>
import { runCookieConsent, resetCookieConsent } from '~/composables/useCookieConsent.js'

const config = useRuntimeConfig()
const { locale, t } = useI18n()

const init = () => {
  resetCookieConsent()
  runCookieConsent({
    revision: config.public.cookiesRevision || 0,
    language: locale.value,
    t,
  })
}

onMounted(() => {
  setTimeout(init, 500)
})

watch(locale, () => {
  resetCookieConsent()
  init()
})
</script>

<template>
  <div style="display: none" aria-hidden="true"></div>
</template>
